export const USR_ROLES: string[] = [
  'https://healthyvirtuoso.com/auth/platform.admin',
  'https://healthyvirtuoso.com/auth/platform.betatester'
];
